import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { BallMark } from './icons/HandballMarks';
import { heroChips, offer } from '../data/content';
import { OFFER_SECTION_ID } from '../utils/scroll';
export function Hero() {
  const hasCheckout = Boolean(offer.checkoutUrl);
  const ctaLabel = hasCheckout ? 'Jetzt kaufen – 19 €' : 'Jetzt entdecken – 19 €';
  return <header className="relative overflow-hidden bg-navy-900 px-4 pb-10 pt-4 sm:px-6 sm:pb-14 sm:pt-10" data-id="element-66" data-mp="129qs1epkbdkp">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-67" data-mp="xbfmvha7pr8t">
        <p className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-gold/40 bg-gold/10 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-gold sm:text-[11px]" data-id="element-68" data-mp="sarsqmqosuad">
          <BallMark className="h-3 w-3 sm:h-3.5 sm:w-3.5" data-id="element-69" data-mp="3d1sbczku5nu6" />
          Für Lehrkräfte &amp; Trainer
        </p>

        <h1 className="mt-3 max-w-[343px] font-display text-[29px] font-black leading-[1.06] text-white sm:mt-5 sm:max-w-none sm:text-5xl lg:text-[56px]" data-id="element-70" data-mp="381e0l9runzsg">
          Mit Plan ins{' '}
          <span className="text-gold-light" data-id="element-71" data-mp="3o7vkflb27pxt">Kinderhandball-Training.</span>
        </h1>

        <p className="mt-3 max-w-[343px] text-[14px] leading-[20px] text-white/75 sm:mt-4 sm:max-w-xl sm:text-base sm:leading-relaxed" data-id="element-72" data-mp="39auqdb5ebiw6">
          6 Praxisbände für dein Training mit Kindern von 6 bis 12 Jahren.
        </p>

        <ul className="mt-3 flex flex-wrap items-center justify-center gap-2 sm:mt-5" data-id="element-73" data-mp="30gzvcvxzn8u9">
          {heroChips.map(chip => <li key={chip} className="inline-flex items-center gap-1.5 rounded-full border border-[#20c65a]/40 bg-[#20c65a]/10 px-2.5 py-1 text-[12px] font-semibold text-[#5ce08c] sm:px-3 sm:text-[13px]" data-id="element-74" data-mp="35a2fyeksf7yb">
              <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-75" data-mp="2hina4btsy8ib" />
              {chip}
            </li>)}
        </ul>

        <div className="relative mt-3 w-full sm:mt-6" data-id="element-76" data-mp="2ljgz78izdtcs">
          <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-0" style={{
          background: 'radial-gradient(60% 55% at 50% 50%, rgba(32,198,90,0.16) 0%, rgba(212,175,55,0.10) 45%, rgba(5,13,24,0) 75%)'
        }} data-id="element-77" data-mp="s1rqcip57wrn" />
          <img src="https://cdn.magicpatterns.com/uploads/6KhNttfB83uE4XCLT1fa1p/Imagen_de_Codex_22_sept_2026,_10_18_19_a.m..png" alt="Die sechs KINDERHANDBALL-Bände als digitale Ausgaben auf Monitor, Tablet und Smartphone" width={1240} height={1240} className="relative mx-auto block h-[290px] w-full max-w-[300px] object-contain sm:h-auto sm:max-h-[440px] sm:max-w-[560px]" data-id="element-78" data-mp="ddnf1zsf6niw" />
        </div>

        <div className="mt-4 w-full max-w-[380px] sm:mt-6" data-id="element-79" data-mp="x37falufynfb">
          <CtaButton label={ctaLabel} targetId={OFFER_SECTION_ID} href={offer.checkoutUrl} showArrow data-id="element-80" data-mp="3ltqdrg1k11v3" />
          <p className="mt-2.5 text-[12px] font-semibold text-white/70" data-id="element-81" data-mp="1x9ku2l5yd2go">
            Einmalzahlung · 6 PDFs · Auf Deutsch
          </p>
          <p className="mt-1 text-[11px] text-white/45" data-id="element-82" data-mp="21bpmjgknzt1q">
            Kein physischer Versand
          </p>
        </div>
      </div>
    </header>;
}